import { Container, Stack, Typography } from "@mui/material";
import {
  ChannelType,
  PRICE_MODELS,
  PriceModelStruct,
  ServiceType,
} from "@snubes/snubes-types";
import { FC } from "react";
import { array, type } from "superstruct";
import { ControlledCheckboxButtons } from "../../Form/views/ControlledCheckboxButtons";
import { useT } from "../../Translation/hooks/useT";
import { useWizardForm } from "../../Wizard/hooks/useWizardForm";
import { WizardFormProps } from "../../Wizard/types/WizardFormProps";
import { TENDER_PRICE_MODEL } from "../consts/TENDER_PRICE_MODEL";
import { findTenderServiceChannel } from "../helpers/findTenderServiceChannel";
import { useTenderWizardStore } from "../hooks/useTenderWizardStore";

const FormValuesStruct = type({
  priceModels: array(PriceModelStruct),
});

type Props = WizardFormProps<{
  serviceType: ServiceType;
  channelType: ChannelType;
}>;

const PRICE_MODEL_OPTIONS = PRICE_MODELS.map((priceModel) => ({
  ...TENDER_PRICE_MODEL[priceModel],
  value: priceModel,
}));

export const TenderWizardChannelPriceModelsForm: FC<Props> = (props) => {
  const { serviceType, channelType } = props.formProps;
  const t = useT();
  const { control, handleSubmit, onSubmit } = useWizardForm({
    store: useTenderWizardStore,
    formKey: props.formKey,
    FormValuesStruct,
    toFormValues: (tender) => ({
      priceModels:
        findTenderServiceChannel(serviceType, channelType, tender)
          ?.priceModels || [],
    }),
    toDoc: (formValues, tender) => {
      const channel = findTenderServiceChannel(
        serviceType,
        channelType,
        tender,
      );

      if (channel) {
        channel.priceModels = formValues.priceModels || [];
      }

      return {
        services: tender?.services,
        isReviewed: {
          ...tender?.isReviewed,
          services: false,
        },
      };
    },
  });

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Container sx={{ pb: 3 }} maxWidth="md">
        <Typography variant="h1" mb={4}>
          {t("TenderWizardPriceModelsForm_Title_PriceModels")}
        </Typography>
        <Stack spacing={3}>
          <ControlledCheckboxButtons
            control={control}
            name="priceModels"
            options={PRICE_MODEL_OPTIONS}
            gridSpacing={4}
            gridItemXs={4}
          />
        </Stack>
      </Container>
    </form>
  );
};
